var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbIconLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 1.875v8.25a.375.375 0 01-.75 0v-8.25a.375.375 0 11.75 0zM4.5 5.625H2.625V4.5a.375.375 0 00-.64-.265l-1.5 1.5a.375.375 0 000 .53l1.5 1.5a.375.375 0 00.64-.265V6.375H4.5a.375.375 0 000-.75zm7.015.11l-1.5-1.5a.375.375 0 00-.64.265v1.125H7.5a.375.375 0 000 .75h1.875V7.5a.375.375 0 00.64.265l1.5-1.5a.375.375 0 000-.53z",
    fill: "#FEFEFF"
  })));
}

export default __webpack_public_path__ + "static/media/thumb-icon-light.dd64e0c4.svg";
export { SvgThumbIconLight as ReactComponent };